var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/json+ld"}},[_vm._v("\n\t"+_vm._s(_vm.json)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }